export default __webpack_public_path__ + "static/hero_home_img_8-657bdc6d77fe9565deb39c30df577865.png";